import { render, staticRenderFns } from "./postgraduateChat.vue?vue&type=template&id=1aef5cb4&scoped=true&"
import script from "./postgraduateChat.vue?vue&type=script&lang=js&"
export * from "./postgraduateChat.vue?vue&type=script&lang=js&"
import style0 from "./postgraduateChat.vue?vue&type=style&index=0&id=1aef5cb4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aef5cb4",
  null
  
)

export default component.exports